var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndDown)?_c('SubtitlesPresetsBottomSheet'):_c('SubtitlesPresetsDialog')
}
var staticRenderFns = []

export { render, staticRenderFns }